import { createVNode as n, mergeProps as o } from "vue";
import e from "../node_modules/@pf-ui/pf-icon-svg/es/asn/OrganizationFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (t, a) => {
  const i = {
    ...t,
    ...a.attrs
  };
  return n(d, o(i, {
    icon: e
  }), null);
};
r.displayName = "OrganizationFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
